export default "__VITE_ASSET__CSiLs249__"